import BaseUseCase from "../../../base_use_case.js";

class ShowCountryUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/addresses/countries/${identifier}`,
    });
  }
}

const instance = new ShowCountryUseCase();
export default instance;